import { __decorate, __metadata, __param } from "tslib";
import qs from 'qs';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../../symbols';
import { format } from '@/@core/utils/string';
let AdminApi = class AdminApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        /**
         * 获取Admin账号列表
         * @param params
         * @returns
         */
        this.getManagerUserList = (params) => {
            const url = this.urls.getPatsnapAccountList;
            const res = this.http.get({
                url,
                params: {
                    ...params,
                    s_include_role: true,
                },
            });
            return res;
        };
        /**
         * 批量编辑用户角色
         * 编辑用户角色
         * @param params
         * @returns
         */
        this.postEditBatchRoles = (params) => {
            const url = this.urls.postEditBatchRoles;
            const res = this.http.post({
                url,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                data: qs.stringify(params),
            });
            return res;
        };
        /**
         * 添加新用户
         * /backoffice/accounts/patsnap
         */
        this.postAccountsPatsnap = (emails, reseller = false) => {
            const url = this.urls.postAccountsPatsnap;
            const res = this.http.postForm({
                url,
                data: qs.stringify({
                    emails,
                    reseller,
                }),
            });
            return res;
        };
    }
    // 根据关键词查询patsnap 账号列表
    getPatsnapAccountList(params) {
        const url = this.urls.getPatsnapAccountList;
        const res = this.http.get({
            url,
            params,
        });
        return res;
    }
    // 根据用户ID查历史记录
    getHistoryList(params) {
        const url = this.urls.getHistoryList;
        const res = this.http.get({
            url,
            params,
        });
        return res;
    }
    /** 获取审计日志 */
    getAuditLog(params) {
        const url = this.urls.getAuditLog;
        const res = this.http.get({
            url,
            params,
        });
        return res;
    }
    /** 设置用户Reseller状态 */
    postAccountReseller(params) {
        const url = this.urls.postAccountReseller;
        return this.http.post({
            url,
            data: params,
        });
    }
    // #region 组织管理相关方法
    /**
     * 获取部门列表
     * @returns 部门列表
     */
    getDepartmentList() {
        const url = this.urls.getDepartmentList;
        const res = this.http.get({
            url,
        });
        return res;
    }
    /**
     * 新增部门
     * @param params 部门信息
     * @returns 新增的部门信息
     */
    postDepartment(params) {
        const url = this.urls.postDepartment;
        return this.http.post({
            url,
            data: params,
        });
    }
    /**
     * 编辑部门
     * @param params 部门信息
     * @returns 编辑后的部门信息
     */
    putDepartment(params) {
        const url = this.urls.putDepartment;
        return this.http.put({
            url,
            data: params,
        });
    }
    /**
     * 删除部门
     * @param id 部门ID
     * @returns 删除结果
     */
    deleteDepartment(id) {
        const url = format(this.urls.deleteDepartment, { id });
        return this.http.delete({
            url,
        });
    }
    /**
     * 获取员工列表
     * @returns 员工列表
     */
    getEmployeeList(departmentId, page, size, email) {
        const url = this.urls.getEmployeeList;
        const params = {
            page: page,
            size: size,
        };
        if (email) {
            params.email = email;
        }
        else if (departmentId) {
            params.departmentId = departmentId;
        }
        return this.http.get({
            url,
            params,
        });
    }
    /**
     * 新增员工
     * @param params 员工信息
     * @returns 新增的员工信息
     */
    postEmployee(params) {
        const url = this.urls.postEmployee;
        return this.http.post({
            url,
            data: params,
        });
    }
    /**
     * 编辑员工
     * @param params 员工信息
     * @returns 编辑后的员工信息
     */
    putEmployee(params) {
        const url = this.urls.putEmployee;
        return this.http.put({
            url,
            data: params,
        });
    }
    /**
     * 删除员工
     * @param id 员工ID
     * @returns 删除结果
     */
    deleteEmployee(id) {
        const url = format(this.urls.deleteEmployee, { id });
        return this.http.delete({
            url,
        });
    }
    // #endregion
    // #region CORS白名单管理相关方法
    /**
     * 获取所有环境的CORS白名单配置
     * @returns CORS白名单配置列表
     */
    getCorsWhitelist() {
        const url = this.urls.getCorsWhitelist;
        return this.http.get({
            url,
        });
    }
    /**
     * 更新指定环境的CORS白名单配置
     * @param params 环境标识和白名单配置列表
     * @returns 更新结果
     */
    updateCorsWhitelist(params) {
        const url = this.urls.updateCorsWhitelist;
        return this.http.post({
            url,
            data: params,
        });
    }
    // #endregion
    // #region SSO redirect_uri白名单管理相关方法
    /**
     * 获取所有SSO redirect_uri白名单配置
     * @returns SSO redirect_uri白名单配置列表
     */
    getSsoRedirectWhitelist() {
        const url = this.urls.getSsoRedirectWhitelist;
        return this.http.get({
            url,
        });
    }
    /**
     * 更新SSO redirect_uri白名单配置
     * @param params 白名单配置列表
     * @returns 更新结果
     */
    updateSsoRedirectWhitelist(params) {
        const url = this.urls.updateSsoRedirectWhitelist;
        return this.http.post({
            url,
            data: params,
        });
    }
};
AdminApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.IAdminUrls)),
    __metadata("design:paramtypes", [Object, Object])
], AdminApi);
export { AdminApi };
